export const NotificationKeys = {
  base: ['notifications'],
  byId: notificationId => [...NotificationKeys.base, notificationId],
  unread: ['notifications', 'unread'],
  unreadSummary: ['notifications', 'unread', 'summary'],
  all: () => ['notifications', 'all']
};
